import React, { useState } from 'react'
import './styles.scss'
import { config } from './config'

export const SingleChoice = ({ options, submit }: askTheQuestionProps) => {
  const [selected, setSelected] = useState<string | undefined>()
  const [formState, setFormState] = useState<'loaded' | 'send' | 'error'>(
    'loaded'
  )
  let groupname = Date.now().toString()
  return (
    <div className='SingleChoice'>
      <form
        onSubmit={(e: React.FormEvent) => {
          e.preventDefault()

          if (!selected) {
            setFormState('error')
            return
          }

          submit(selected)
        }}
      >
        <div>
          {options &&
            options.map((a, i) => (
              <label className='radio' key={i}>
                <span className='radio__input'>
                  <input
                    type='radio'
                    name={groupname}
                    value={'option' + (i + 1)}
                    onChange={e => {
                      setSelected(e.target.value)
                    }}
                  />
                  <span className='radio__control'></span>
                </span>
                <span className='radio__label'> {a} </span>
              </label>
            ))}
        </div>

        <div className='assistivetext'>Wählen sie eine der Optionen!</div>
        <div className='actionrow'>
          <button disabled={!selected} type='submit'>
            Antworten
          </button>
        </div>
      </form>
    </div>
  )
}
